import React from "react";
import CustomSelect from "../common/Select";

const opcionesClasificacionRiesgo = [
  { value: "bajo", label: "RIESGO BAJO" },
  { value: "medio", label: "RIESGO MEDIO" },
  { value: "alto", label: "RIESGO ALTO" }
];

function SelectorClasificacionRiesgo({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesClasificacionRiesgo}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Clasificación de riesgo"
      error={error}
      required={required}
    />
  );
}

export default SelectorClasificacionRiesgo;